import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import SocialLinks from "components/reuseable/SocialLinks"

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      support: wpMenu(name: { eq: "Footer Support" }) {
        menuItems {
          nodes {
            id
            uri
            label
          }
        }
      }
      legal: wpMenu(name: { eq: "Footer Legal" }) {
        menuItems {
          nodes {
            id
            uri
            label
          }
        }
      }
    }
  `)

  const footerSupportLinks = data.support.menuItems.nodes
  const footerLegalLinks = data.legal.menuItems.nodes

  const year = new Date().getFullYear()

  const widget = (list, title) => {
    return (
      <div className="widget">
        <h4 className="widget-title text-white mb-3">{title}</h4>
        <ul className="list-unstyled text-reset mb-0">
          {list.map(({ uri, label, id }) => (
            <li key={id}>
              <Link to={uri}>{label}</Link>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return (
    <footer className="bg-dark text-inverse">
      <div className="container pt-20 pt-lg-21 pb-7">
        <div className="row gy-6 gy-lg-0">
          <div className="col-md-3">
            <div className="widget">
              <p className="lead mb-5">
                com2com, founded in 2007 by Salvatore Fortunato and Jean-Paul
                Roskin, delivers your trade-fair stand 24 hours in advance.
                Ahead of time, Ahead of stress.
              </p>
            </div>
          </div>

          <div className="col-md-2 offset-md-2">
            {widget(footerSupportLinks, "Need Help?")}
          </div>

          <div className="col-md-2">{widget(footerLegalLinks, "Legal")}</div>

          <div className="col-md-3">
            <div className="widget">
              <h4 className="widget-title text-white mb-3">Get in Touch</h4>
              <address>
                Oudemanstraat 24
                <br />
                1880 Kapelle-op-den-Bos
                <br />
                Belgium
              </address>
              <a href="mailto:info@com2com.be">info@com2com.be</a>
              <br /> <a href="tel:+32(0)15411705">+32 (0)15 41 17 05</a>
            </div>
          </div>
        </div>

        <hr className="mt-13 mt-md-15 mb-7" />

        <div className="d-md-flex align-items-center justify-content-between">
          <p className="mb-2 mb-lg-0">
            ©{` ${year} - `}com2com. All rights reserved.
          </p>
          <SocialLinks className="nav social social-white text-md-end" />
        </div>
      </div>
    </footer>
  )
}

export default Footer
